import React from 'react'
import styles from './HamburgerMenu.module.scss'
import { VelocityComponent } from 'velocity-react'

export const HAMBURGER_FOLDING_DURATION = 400
const HAMBURGER_SPINNING_DURATION = 2000

interface HamburgerProps {
  isActive: boolean
  onClick: () => void
}

export const HamburgerMenu: React.FC<HamburgerProps> = (props) => {
  return (
    <div className={styles.hamburger} onClick={props.onClick}>
      <VelocityComponent
        animation={
          props.isActive
            ? {
                rotateZ: '315deg',
              }
            : {
                top: '20%',
              }
        }
        duration={props.isActive ? HAMBURGER_SPINNING_DURATION : HAMBURGER_FOLDING_DURATION}
        easing={props.isActive ? [500, 20] : 'swing'}
      >
        <VelocityComponent
          animation={
            props.isActive
              ? {
                  top: '50%',
                }
              : { rotateZ: '0deg' }
          }
          duration={props.isActive ? HAMBURGER_FOLDING_DURATION : HAMBURGER_SPINNING_DURATION}
          easing={props.isActive ? 'swing' : [500, 20]}
        >
          <div className={styles.bar1}></div>
        </VelocityComponent>
      </VelocityComponent>

      <VelocityComponent
        animation={{ opacity: props.isActive ? 0 : 1 }}
        delay={props.isActive ? HAMBURGER_FOLDING_DURATION : HAMBURGER_SPINNING_DURATION}
        duration={0}
      >
        <div className={styles.bar2}></div>
      </VelocityComponent>

      <VelocityComponent
        animation={
          props.isActive
            ? {
                rotateZ: '405deg',
              }
            : {
                top: '80%',
              }
        }
        duration={props.isActive ? HAMBURGER_SPINNING_DURATION : HAMBURGER_FOLDING_DURATION}
        easing={props.isActive ? [500, 20] : 'swing'}
      >
        <VelocityComponent
          animation={
            props.isActive
              ? {
                  top: '50%',
                }
              : { rotateZ: '0deg' }
          }
          duration={props.isActive ? HAMBURGER_FOLDING_DURATION : HAMBURGER_SPINNING_DURATION}
          easing={props.isActive ? 'swing' : [500, 20]}
        >
          <div className={styles.bar3}></div>
        </VelocityComponent>
      </VelocityComponent>
    </div>
  )
}
